import {
    Box,
    Button,
    Grid,
    GridSize,
    IconButton,
    Paper,
    SxProps,
    Theme,
    Typography
} from '@mui/material';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import http from '../../commonFunctions/httpClient';
// import '../../Components/Slider/WSSlider.css';
import { storeDataComponent } from '../../StateManagement/actions';
import ThreeDotMenu from '../ThreeDotMenu/ThreeDotMenu';
import { dateFormat } from '../../commonFunctions/CommonFunctions';
import NotesOutlinedIcon from '@mui/icons-material/NotesOutlined';
import { WSIcons } from '../../commonFunctions/iIcons';
interface IMobileDataGridAdvancedDataGridProps {
    id: string;
    title?: string;
    columns: IOrderColumns[];
    sortedOptions?: { value: string | number; label: string, disabled?: boolean }[];
    onSelectionChange?: (selectedRows: any[]) => void;
    source?: {
        url: string;
        pageSize: number;
        page: number;
        filter: any[];
        sort: any[];
        type?: 'POST' | 'GET'
    };
    data?: Array<any>
    filters?: any;
    transFormData?: (data: any) => any;
    viewStyle?: 'Grid' | 'Single'
    showpagination?: boolean
    handleIconClick?: (e: any, data: string) => void
    onAddButtonClick?: () => void;
    addButton?: any;
}
export interface IMobAdvdColumns {
    header: string;
    fieldName: string;
    type?: 'default' | 'link' | 'image' | 'rating' | 'amount' | 'date' | 'hoverImage' | 'action' | 'divider';
    tooltip?: boolean;
    hoverField?: string;
    actions?: any;
    defaultSort?: string;
    actionCallback?: (action: string, row: any) => void;
    sortable?: boolean; // Indicate if column is sortable
    sortKey?: string
    labelSx?: SxProps<Theme>;
    ToWhichFieldToApplyStyle?: string,
    byOrder?: number,
    labelStyleFor?: "Both" | "Grid" | "Single"
    columnFor?: "Both" | "Grid" | "Single"

}
export interface IOrderColumns {
    header: string;
    fieldName: string;
    type?: 'default' | 'link' | 'image' | 'rating' | 'amount' | 'date' | 'hoverImage' | 'action' | 'divider';
    tooltip?: boolean;
    hoverField?: string;
    actions?: any;
    defaultSort?: string;
    actionCallback?: (action: string, row: any) => void;
    sortable?: boolean;
    sortKey?: string;
    labelSx?: SxProps<Theme>;
    byOrder?: number;
    position?: 'Left' | 'Right' | 'Middle' | 'Same Column';
    otherFiels?: IOtherFields[]
    description?: string;
    isBoderRadious?: boolean,
    sm?: boolean | GridSize | undefined
}
interface IOtherFields {
    fieldName: string
    type?: 'default' | 'link' | 'image' | 'rating' | 'amount' | 'date' | 'hoverImage' | 'action' | 'divider';
    labelSx?: SxProps<Theme>;
    descriptionSuffix?: string;
    descriptionPrefix?: string;
    actions?: any;
    actionCallback?: (action: string, row: any) => void;
}
interface OrderItem {
    id: string;
    image: string;
    title: string;
    price: number;
    color?: string;
    size?: string;
    deliveryDate: string;
    status: string;
}
const WSMobileDataGridAdvanced: React.FC<IMobileDataGridAdvancedDataGridProps> = ({
    id,
    columns,
    onSelectionChange,
    source,
    filters,
    transFormData,
    title,
    showpagination = true,
    data,
    handleIconClick,
    sortedOptions,
    viewStyle = 'Grid',
    onAddButtonClick,
    addButton
}) => {
    const { control } = useForm()
    const [visibleOrders, setVisibleOrders] = useState(5);
    const [rows, setRows] = useState<OrderItem[]>(data || []);
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState<boolean>(true);
    const gridRef = useRef<HTMLDivElement | null>(null);
    const [gridHeight, setGridHeight] = useState<number | null>(null);
    const [totalCount, setTotalCount] = useState<number>(0);
    const [sortConfig, setSortConfig] = useState<{ key: string; direction: 'asc' | 'desc' }>({
        key: '',
        direction: 'desc',
    });

    const dispatch = useDispatch();

    const handleShowMore = () => {
        console.log(visibleOrders)
        if (!data) {
            setVisibleOrders((prev) => prev + 5);
            let pageRow = rowsPerPage + 5;

            setRowsPerPage(pageRow)
        }
        else if (data && data?.length > 5) {
            const startIndex: any = page !== 0 ? (page) * rowsPerPage : page;
            const paginatedData: any = data.slice(0, startIndex + rowsPerPage);
            setRows(paginatedData);
            //setRows(data);
            setTotalCount(data?.length)
            setVisibleOrders((prev) => prev + 5)
            //  setRowsPerPage(5)
            dispatch(storeDataComponent(id, data || []));
        }
    };

    const fetchDataFromAPI = async (
        page: number,
        pageSize: number,
        filter: any[] = [],
        sort: any[] = []
    ) => {
        try {
            setLoading(true);
            const response: any = source?.type === 'GET'
                ? await http.get(source.url)
                : await http.post(source?.url || '', {
                    page,
                    pageSize,
                    filter,
                    sort: source?.sort.length ? source.sort : sort,
                });
            setHasMore(response?.pagination?.hasMore);
            setTotalCount(response?.pagination?.totalCount | 0);
            return response?.data || [];
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        } finally {
            setLoading(false);
        }
    };

    const loadPageData = useCallback(async () => {
        try {
            if (source) {
                const sortKey = sortConfig.key || 'Id';
                const sort = [{ field: sortKey, direction: sortConfig.direction }];
                const filtersToApply = filters || source.filter || [];

                const response = await fetchDataFromAPI(page, rowsPerPage, filtersToApply, sort);
                const transformedData = transFormData ? transFormData(response) : response;
                setRows(transformedData);

                dispatch(storeDataComponent(id, transformedData));
            }
        } catch (error) {
            console.error('Error loading page data:', error);
        }
    }, [page, rowsPerPage, sortConfig, filters, source, transFormData, id, dispatch]);

    useEffect(() => {
        if (!data) {
            loadPageData();
        }

    }, [page, rowsPerPage, sortConfig, visibleOrders]);
    useEffect(() => {
        if (gridRef.current) {
            setGridHeight(gridRef.current.offsetHeight);
        }
    }, []);
    const handleAddButton = () => {
        if (onAddButtonClick) {
            onAddButtonClick();
        }
    }
    const renderGrid = (row: any, index: number) => (
        <Paper
            key={row.id || index}
            elevation={0}
            sx={{
                padding: 2,
                marginBottom: 2,
                borderRadius: 4,
                display: 'flex',
                alignItems: 'flex-start',
                border: '1px solid #B3B6CC',
                //gap: 2,
                width: '100%',
                transition: 'box-shadow 0.3s ease-in-out, background-color 0.3s ease-in-out',
                backgroundColor: '#fff', // Default background color 
                '&:hover': {
                    //  backgroundColor: '#f5f5f5', // Slightly darker background on hover
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)', // Shadow effect
                },
            }}
        >

            <Box
                sx={{
                    width: '1px',
                    height: `${gridHeight}px`,
                    backgroundColor: 'red',
                    marginX: 2, // optional spacing
                    marginLeft: -1
                }}
            ></Box>

            <Grid item container spacing={1} ref={gridRef} >
                {columns.map((column, colIndex) => (<>

                    {/* <Box key={colIndex} sx={{ paddingTop: 0, paddingLeft: 2 }}>
                        {column.type === 'image' && (
                            <Box
                                component="img"

                                src={row[column.fieldName]}
                                alt={row[column.fieldName]}
                                sx={{
                                    width: 80,
                                    height: 80,

                                    objectFit: 'contain',
                                    borderRadius: 1,
                                }}
                            />
                        )}
                    </Box> */}


                    {column.type === 'default' &&

                        <Grid item xs={column?.sm || 10} >
                            <Box sx={{ border: column?.isBoderRadious ? '1px solid red' : undefined, borderRadius: 3, padding: column?.isBoderRadious ? 1 : 0, fontSize: column?.isBoderRadious ? '0.5rem' : '0.75rem' }}>  <Typography variant="subtitle1" sx={column.labelSx}>
                                {row[column.fieldName] !== '' ? row[column.fieldName] : '-'}
                            </Typography>
                            </Box>
                            {column.otherFiels && column.otherFiels.length > 0 &&
                                column.otherFiels.map((other: IOtherFields) => (
                                    <>
                                        {other.type === 'default' && <Typography variant="subtitle1" sx={other.labelSx}>
                                            {other?.descriptionPrefix ? other?.descriptionPrefix : ''} {row[other.fieldName]}   {other?.descriptionSuffix ? other?.descriptionSuffix : ''}
                                        </Typography>}
                                        {other.type === 'amount' && <Typography variant="subtitle1" sx={other.labelSx}>
                                            {other?.descriptionPrefix ? other?.descriptionPrefix : ''}  ₹{row[other.fieldName]}{other?.descriptionSuffix ? other?.descriptionSuffix : ''}
                                        </Typography>}
                                        {
                                            other.type === 'action' && other.actions?.map((label: string) => (
                                                <Box>
                                                    <ThreeDotMenu
                                                        items={column.actions} align='horizontal'
                                                        onAction={(action: string) =>
                                                            column.actionCallback?.(action, row)
                                                        }
                                                    />
                                                </Box>
                                            ))
                                        }
                                    </>
                                ))

                            }
                        </Grid>
                    }
                    {column.type === 'amount' &&

                        <Grid item xs={column?.sm || 10}>
                            <Box sx={{ border: column?.isBoderRadious ? '1px solid red' : undefined, borderRadius: 3, padding: column?.isBoderRadious ? 1 : 0, fontSize: column?.isBoderRadious ? '0.5rem' : '0.75rem' }}>  <Typography variant="subtitle1" sx={column.labelSx}></Typography>
                                <Typography variant="subtitle1" sx={column.labelSx}>
                                    ₹{row[column.fieldName] !== '' ? row[column.fieldName] : '0'}
                                </Typography>
                            </Box>
                            {column.otherFiels && column.otherFiels.length > 0 &&
                                column.otherFiels.map((other: IOtherFields) => (
                                    <>
                                        {other.type === 'default' && <Typography variant="subtitle1" sx={other.labelSx}>
                                            {row[other.fieldName]}
                                        </Typography>}
                                        {other.type === 'amount' && <Typography variant="subtitle1" sx={other.labelSx}>
                                            ₹{row[other.fieldName]}
                                        </Typography>}
                                        {
                                            other.type === 'action' && other.actions?.map((label: string) => (
                                                <Box>
                                                    <ThreeDotMenu
                                                        items={column.actions} align='horizontal'
                                                        onAction={(action: string) =>
                                                            column.actionCallback?.(action, row)
                                                        }
                                                    />
                                                </Box>
                                            ))
                                        }
                                    </>
                                ))

                            }
                        </Grid>
                    }
                    {column.type === 'date' &&

                        <Grid item sm={column?.sm} xs={column?.sm || 9} >
                            <Box
                                sx={{
                                    border: column?.isBoderRadious ? '1px solid #B3B6CC' : undefined,
                                    borderRadius: 3,
                                    padding: column?.isBoderRadious ? 1 : 0,
                                    fontSize: column?.isBoderRadious ? '0.5rem' : '0.75rem',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    textAlign: 'center', // optional, just in case
                                }}
                            > <Typography sx={{ fontSize: column?.isBoderRadious ? '0.75rem' : '0.875rem' }} >{column.header}</Typography>
                                <Typography  sx={{ ...column.labelSx, fontSize: column?.isBoderRadious ? '0.75rem' : '0.875rem',marginLeft:1 }}>
                                    {dateFormat(row[column.fieldName], "DD-MM-YYYY")}
                                </Typography>
                            </Box>

                            {column.otherFiels && column.otherFiels.length > 0 &&
                                column.otherFiels.map((other: IOtherFields) => (
                                    <>
                                        {other.type === 'default' && <Typography variant="subtitle1" sx={other.labelSx}>
                                            {row[other.fieldName]}
                                        </Typography>}
                                        {other.type === 'amount' && <Typography variant="subtitle1" sx={other.labelSx}>
                                            ₹{row[other.fieldName]}
                                        </Typography>}
                                        {
                                            other.type === 'action' && other.actions?.map((label: string) => (
                                                <Box>
                                                    <ThreeDotMenu
                                                        items={column.actions} align='horizontal'
                                                        onAction={(action: string) =>
                                                            column.actionCallback?.(action, row)
                                                        }
                                                    />
                                                </Box>
                                            ))
                                        }
                                    </>
                                ))

                            }
                        </Grid>
                    }


                    {column.type === 'action' && (<>
                        <Grid item sm={column?.sm || 2} xs={12}>
                            <Box display="flex" justifyContent="flex-end">
                                <ThreeDotMenu
                                    align="vertical"
                                    items={column.actions}
                                    onAction={(action: string) =>
                                        column.actionCallback?.(action, row)
                                    }
                                />
                            </Box>
                        </Grid>

                    </>
                    )}

                </>))}


            </Grid>
        </Paper>
    );

    return (
        <Grid item container spacing={2} sx={{ padding: 2, marginBottom: 5, width: '100%',marginLeft:0 }}>
            <Grid item sm={12}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: '#1E4572',
                    padding: '8px 16px',
                    borderRadius: '8px',
                    marginBottom: 2,
                    width: '100%'
                }}
            >
                {/* Icon Box */}
                {/* <Grid item sm={12}
                    sx={{
                        width: '100%',
                        height: 35,
                        backgroundColor: '#F3F6FC',
                        borderRadius: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginRight: 2,

                    }}
                >
                    <NotesOutlinedIcon sx={{ color: '#1E4572' }} />
                </Grid> */}

                {/* Text */}
                <Typography variant="subtitle1" sx={{ color: '#FFFFFF', fontWeight: 600 }}>
                    {title}
                </Typography>

                {/* Divider */}
                <Typography sx={{ color: '#C1C8D4', marginX: 1 }}>|</Typography>

                <Typography variant="subtitle2" sx={{ color: '#C1C8D4' }}>
                    {totalCount} Records
                </Typography>
                {addButton && <IconButton
                    sx={{
                        backgroundColor: '#7D79C2',
                        borderRadius: 1,
                        //padding: '8px',
                        width: '38px',
                        height: '32px',
                        display: 'flex',
                        alignItems: 'center',
                        marginLeft: 12,
                        marginRight: 2,
                        //  marginRight: (!exportCsv || !addButton) ? 1 : 0,
                        justifyContent: 'center',


                    }}
                    onClick={handleAddButton}>
                    <WSIcons.AddIcon style={{ color: 'white' }} />

                </IconButton>}

            </Grid>
            {rows.slice(0, visibleOrders).map((row, index) => renderGrid(row, index))}
            {(
                hasMore === true && <Box flex={1} textAlign="center" alignItems={'center'} alignContent={'center'} sx={{ marginTop: 2,marginLeft:0 ,backgroundColor:'#7D79C2'}}>
                    <Button sx={{color:'#fff'}} variant="outlined" onClick={handleShowMore}>
                        Show More {title}
                    </Button>
                </Box>
            )}
        </Grid>
    );
};


export default WSMobileDataGridAdvanced;
